export default __webpack_public_path__ + "static/media/illumidesk.6ee2869f.svg";